import { Api } from './Api'

const discountsPathTo = {
  list: (params) => {
    return Api.request({
      url: '/discounts.json',
      method: 'get',
      params
    })
  },
  get: (id) => {
    return Api.request({
      url: `/discounts/${id}.json`,
      method: 'get',
    })
  },
  save: (data) => {
    return Api.request({
      url: '/discounts.json',
      method: 'post',
      data: { discount: data }
    })
  },
  update: (id, data) => {
    return Api.request({
      url: `/discounts/${id}.json`,
      method: 'put',
      data: { discount: data }
    })
  },
  delete: (id) => {
    return Api.request({
      url: `/discounts/${id}.json`,
      method: 'delete',
    })
  },
  activate: (id) => {
    return Api.request({
      url: `/discounts/${id}/activate.json`,
      method: 'put',
    })
  },
  deactivate: (id) => {
    return Api.request({
      url: `/discounts/${id}/deactivate.json`,
      method: 'put',
    })
  },
  joinCampaign: (id, campaignId) => {
    return Api.request({
      url: `/discounts/${id}/join_campaign.json`,
      method: 'put',
      data: { campaign_id: campaignId }
    })
  },
  leaveCampaign: (id) => {
    return Api.request({
      url: `/discounts/${id}/leave_campaign.json`,
      method: 'put',
    })
  },
  addItem: (discountId, data) => {
    return Api.request({
      url: `/discounts/${discountId}/items.json`,
      method: 'post',
      data: { discount_item: data }
    })
  },
  addItems: (discountId, items) => {
    return Api.request({
      url: `/discounts/${discountId}/items.json`,
      method: 'post',
      data: { discount_items: items }
    })
  },
  updateItem: (id, data) => {
    return Api.request({
      url: `/discount_items/${id}.json`,
      method: 'put',
      data: { discount_item: data }
    })
  },
  deleteItem: (id) => {
    return Api.request({
      url: `/discount_items/${id}.json`,
      method: 'delete',
    })
  }
}

export default discountsPathTo
